<template>
  <div class="box_1 flex-col">
    <!-- 将"课程资源"置于"竞赛引领"正上方 -->
    <div class="section_1 flex-row justify-between" :class="{ 'active-menu': contentType === '课程资源' }" @click="emitSwitch('课程资源')" style="cursor: pointer;">
      <span class="text_10">课程资源</span>
      <img class="thumbnail_3" referrerpolicy="no-referrer" :src="img('SketchPng747db5e889a13bf4fb9dd0a589508efe343f959ef87a07a254a0ed6a1993f7e0.png')" />
    </div>
    <img class="image_3" referrerpolicy="no-referrer" :src="img('SketchPng9c3ce8bd283950762492e35258281653adc3f1ab8503324199e50d09865cffe9.png')" />

    <div class="section_2 flex-row justify-between" :class="{ 'active-menu': contentType === '竞赛引领' }" @click="emitSwitch('竞赛引领')" style="cursor: pointer;">
      <span class="text_11">竞赛引领</span>
      <img class="thumbnail_4" referrerpolicy="no-referrer" :src="img('SketchPng747db5e889a13bf4fb9dd0a589508efe343f959ef87a07a254a0ed6a1993f7e0.png')" />
    </div>
    <img class="image_4" referrerpolicy="no-referrer" :src="img('SketchPng9c3ce8bd283950762492e35258281653adc3f1ab8503324199e50d09865cffe9.png')" />

    <!-- 其余维持原顺序 -->
    <div class="section_3 flex-row justify-between" :class="{ 'active-menu': contentType === '数智融合' }" @click="emitSwitch('数智融合')" style="cursor: pointer;">
      <span class="text_12">数智融合</span>
      <img class="thumbnail_5" referrerpolicy="no-referrer" :src="img('SketchPng747db5e889a13bf4fb9dd0a589508efe343f959ef87a07a254a0ed6a1993f7e0.png')" />
    </div>
    <img class="image_5" referrerpolicy="no-referrer" :src="img('SketchPng9c3ce8bd283950762492e35258281653adc3f1ab8503324199e50d09865cffe9.png')" />

    <div class="section_4 flex-row justify-between" :class="{ 'active-menu': contentType === '证书赋能' }" @click="emitSwitch('证书赋能')" style="cursor: pointer;">
      <span class="text_13">证书赋能</span>
      <img class="thumbnail_6" referrerpolicy="no-referrer" :src="img('SketchPng747db5e889a13bf4fb9dd0a589508efe343f959ef87a07a254a0ed6a1993f7e0.png')" />
    </div>
    <img class="image_6" referrerpolicy="no-referrer" :src="img('SketchPng9c3ce8bd283950762492e35258281653adc3f1ab8503324199e50d09865cffe9.png')" />

    <div class="section_5 flex-row justify-between" :class="{ 'active-menu': contentType === '双师团队' }" @click="emitSwitch('双师团队')" style="cursor: pointer;">
      <span class="text_14">双师团队</span>
      <img class="thumbnail_7" referrerpolicy="no-referrer" :src="img('SketchPng747db5e889a13bf4fb9dd0a589508efe343f959ef87a07a254a0ed6a1993f7e0.png')" />
    </div>
    <img class="image_7" referrerpolicy="no-referrer" :src="img('SketchPng9c3ce8bd283950762492e35258281653adc3f1ab8503324199e50d09865cffe9.png')" />

    <div class="section_6 flex-row justify-between" :class="{ 'active-menu': contentType === '文化浸润' }" @click="emitSwitch('文化浸润')" style="cursor: pointer;">
      <span class="text_15">文化浸润</span>
      <img class="thumbnail_8" referrerpolicy="no-referrer" :src="img('SketchPng747db5e889a13bf4fb9dd0a589508efe343f959ef87a07a254a0ed6a1993f7e0.png')" />
    </div>
    <img class="image_8" referrerpolicy="no-referrer" :src="img('SketchPng9c3ce8bd283950762492e35258281653adc3f1ab8503324199e50d09865cffe9.png')" />

    <div class="section_7 flex-row justify-between" :class="{ 'active-menu': contentType === '资源辐射' }" @click="emitSwitch('资源辐射')" style="cursor: pointer;">
      <span class="text_16">资源辐射</span>
      <img class="thumbnail_9" referrerpolicy="no-referrer" :src="img('SketchPng747db5e889a13bf4fb9dd0a589508efe343f959ef87a07a254a0ed6a1993f7e0.png')" />
    </div>
    <img class="image_9" referrerpolicy="no-referrer" :src="img('SketchPng9c3ce8bd283950762492e35258281653adc3f1ab8503324199e50d09865cffe9.png')" />

    <div class="section_8 flex-row justify-between" :class="{ 'active-menu': contentType === '实训基地' }" @click="emitSwitch('实训基地')" style="cursor: pointer;">
      <span class="text_17">实训基地</span>
      <img class="thumbnail_10" referrerpolicy="no-referrer" :src="img('SketchPng747db5e889a13bf4fb9dd0a589508efe343f959ef87a07a254a0ed6a1993f7e0.png')" />
    </div>
    <img class="image_10" referrerpolicy="no-referrer" :src="img('SketchPng9c3ce8bd283950762492e35258281653adc3f1ab8503324199e50d09865cffe9.png')" />
  </div>
</template>

<script>
export default {
  name: 'LanhuSideMenu',
  props: {
    contentType: {
      type: String,
      default: '课程资源'
    }
  },
  methods: {
    emitSwitch(type) {
      this.$emit('switch', type);
    },
    img(name) {
      return require(`../views/lanhu_wenzhangxiangqing/assets/img/${name}`);
    }
  }
};
</script>

<style scoped>
/* 悬浮效果 */
.section_1:hover, .section_2:hover, .section_3:hover, .section_4:hover,
.section_5:hover, .section_6:hover, .section_7:hover, .section_8:hover {
  background-color: #e8f4fd !important;
  border-left: 4px solid #215195 !important;
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 8px 0 !important;
  margin: 20px 0 0 0 !important;
  width: 100% !important;
  height: auto !important;
  min-height: 41px !important;
  border-radius: 4px !important;
  box-sizing: border-box !important;
}

/* 选中状态高亮效果 */
.section_1.active-menu, .section_2.active-menu, .section_3.active-menu, .section_4.active-menu,
.section_5.active-menu, .section_6.active-menu, .section_7.active-menu, .section_8.active-menu {
  background-color: #215195 !important;
  border-left: 4px solid #ff6b35 !important;
  color: white !important;
  padding: 8px 0 !important;
  margin: 20px 0 0 0 !important;
  width: 100% !important;
  height: auto !important;
  min-height: 41px !important;
  border-radius: 4px !important;
  box-sizing: border-box !important;
}

/* 选中状态下文字颜色和布局 */
.section_1.active-menu .text_10,
.section_2.active-menu .text_11,
.section_3.active-menu .text_12,
.section_4.active-menu .text_13,
.section_5.active-menu .text_14,
.section_6.active-menu .text_15,
.section_7.active-menu .text_16,
.section_8.active-menu .text_17 {
  color: white !important;
  font-weight: 700 !important;
  margin: 0 !important;
  line-height: 25px !important;
  padding-left: 30px !important;
  display: flex !important;
  align-items: center !important;
  height: 25px !important;
}

/* 悬浮状态下文字颜色和布局 */
.section_1:hover .text_10,
.section_2:hover .text_11,
.section_3:hover .text_12,
.section_4:hover .text_13,
.section_5:hover .text_14,
.section_6:hover .text_15,
.section_7:hover .text_16,
.section_8:hover .text_17 {
  color: black !important;
  font-weight: 600 !important;
  margin: 0 !important;
  line-height: 25px !important;
  padding-left: 30px !important;
  display: flex !important;
  align-items: center !important;
  height: 25px !important;
}

/* 确保菜单项使用flexbox布局 */
.section_1, .section_2, .section_3, .section_4,
.section_5, .section_6, .section_7, .section_8 {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  box-sizing: border-box !important;
}
</style>

<!-- 复用页面样式定义（非 scoped，确保类名在子组件内生效） -->
<style lang="css" src="../views/lanhu_wenzhangxiangqing/assets/index.css"></style>